:root {
  /* Brand colors -- coral/pink/purple palette */
  --brand-coral: #FF6B6B;
  --brand-pink: #E84393;
  --brand-purple: #A855F7;
  --brand-orange: #FF8E53;
  --brand-dark: #1A1A2E;
  --brand-gradient: linear-gradient(135deg, #FF6B6B 0%, #E84393 100%);
  --brand-gradient-hover: linear-gradient(135deg, #FF5252 0%, #D63384 100%);
  --brand-gradient-wash: linear-gradient(135deg, rgba(168,85,247,0.15) 0%, rgba(232,67,147,0.15) 50%, rgba(255,107,107,0.10) 100%);

  /* Surface colors */
  --color-dark: #111827;
  --color-muted: #6B7280;
  --color-surface: #FFFFFF;
  --color-background: #F9FAFB;
  --color-border: #E5E7EB;
  --color-success: #10B981;

  /* Typography */
  --font-heading: 'Nunito', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;

  /* Spacing (8-point scale) */
  --spacing-xs: 4px;
  --spacing-sm: 8px;
  --spacing-md: 16px;
  --spacing-lg: 24px;
  --spacing-xl: 32px;
  --spacing-2xl: 48px;
  --spacing-3xl: 64px;
  --spacing-4xl: 96px;

  /* Layout */
  --content-max-width: 1120px;
  --text-max-width: 720px;
  --radius: 8px;
  --header-height: 64px;
}
